var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"number","name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',
         $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }